/* @flow */
import { SessionStore } from "../../src/uidispatcherapi/SessionStore";
import { Request } from "../../src/services/Requests";
const RequestBuilder = new Request.Builder("evaluate", "article");

// TODO (EK): Merge with EvaluateArticleClient
export function getCIPs(country: string, userId: string): Promise<any> {
    if (userId === null) {
        return Promise.reject();
    }
    const template = "/cips/countries/{country}/customers/{userId}";
    return RequestBuilder.path(template, { country, userId }).get();
}

export function fetchArticle(ids: string[], storeId: string, customerId: string): Promise<any> {
    const template = "/betty-variants";
    const query = {
        storeIds: storeId,
        ids,
        country: SessionStore.getCountry(),
        locale: SessionStore.getLocale(),
        customerId: customerId || undefined
    };
    return RequestBuilder.path(template, {}).query(query).get();
}
